.btn-resubmit {
  @apply mx-auto mt-6;
}

.mileage {
  @apply mb-6;
}

@media (min-width: 576px) {
  .btn-resubmit {
    @apply flex flex-col items-end;
  }

  .mileage {
    @apply w-1/2;
  }
}
